import React from "react";
import LineChart, { dataset } from "../../../../../../_components/Chart/Line";
import { getSalesMonthPerDay } from "../../../../../../api/sales";

export default (props) => {
  const ref = React.useRef(null);
  const [data, setData] = React.useState({
    labels: Array.from({ length: new Date().getDate() }, (_, i) =>
      (i + 1).toString()
    ),
    datasets: [
      {
        ...dataset,
        data: [],
        label: "Vendas do mês",
      },
    ],
  });

  function init() {
    getSalesMonthPerDay().then((resp) => {
      let _data = [];
      for (let day = 1; day < new Date().getDate()+1; day++) {
        if (resp[day]) {
          _data.push(resp[day]);
        } else {
          _data.push(0);
        }
      }
      setData({
        labels: data.labels,
        datasets: [
          {
            ...dataset,
            data: _data,
            label: "Vendas do mês",
          },
        ],
      });
    });
  }
  React.useEffect(init, [ref.current]);

  return <LineChart data={data} ref={ref} />;
};



// WEBPACK FOOTER //
// ./src/views/AppViews/Dashboard/components/Charts/SalesPerDays/index.jsx